// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"323739f74c18c2bd6832","293":"057ab516a7526fc51120","518":"56a0e478471032042d39","779":"2e1c5feacc0295095c45"}[chunkId] + ".js";
};